var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 147,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.404 143.967a2 2 0 01-1.996 2.132l-131.962-.006c-1.713 0-2.633-2.012-1.513-3.308L123.55.96c1.17-1.353 3.391-.608 3.509 1.176l9.345 141.831z",
    fill: "url(#paint0_linear_5680_11506)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5680_11506",
    x1: 16.311,
    y1: 179.369,
    x2: 148.433,
    y2: 21.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon4);
export default __webpack_public_path__ + "static/media/Polygon 4.c6795e2ed5fe3f938e8b295a0d225534.svg";
export { ForwardRef as ReactComponent };